import { createRouter, createWebHistory } from 'vue-router'

import LoginView from '../views/LoginView.vue'
import EventsView from '../views/EventsView.vue'
import FundingGroups from '@/views/FundingGroups.vue'
import SwapListView from '../views/signals/SwapListView.vue'
import PageNotFoundView from '../views/PageNotFoundView.vue'
import EyeCexSettingsView from '../views/eye/EyeCexSettingsView.vue'
import FundingListView from '@/views/signals/FundingListView.vue'
import EyeCexView from '@/views/eye/EyeCexView.vue'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import ErrorLayout from '@/layouts/ErrorLayout.vue'
import EmptyLayout from '@/layouts/EmptyLayout.vue'
import EyeLayout from '@/layouts/EyeLayout.vue'
import DexCexListView from '@/views/signals/DexCexListView.vue'
import EyeDexView from '@/views/eye/EyeDexView.vue'
import EyeCommonView from '@/views/eye/EyeCommonView.vue'
import EyeDexSettingsView from '@/views/eye/EyeDexSettingsView.vue'
// import EyeAllAssetView from '@/views/eye/EyeAllAssetView.vue'
import SplashListView from '@/views/signals/SplashListView.vue'
import PoolsView from '@/views/PoolsView.vue'
import UnderMaintenanceView from '@/views/UnderMaintenanceView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'login',
      component: LoginView,
      meta: {
        layout: EmptyLayout,
        title: 'title.login',
      },
    },
    {
      path: '/events',
      name: 'events',
      component: EventsView,
      meta: {
        layout: DefaultLayout,
        title: 'title.listings',
      },
    },
    {
      name: 'listings-redirect',
      path: '/listings',
      redirect: () => {
        return {
          name: 'events',
        }
      },
    },
    {
      path: '/swap',
      name: 'signals-swap',
      component: SwapListView,
      meta: {
        layout: DefaultLayout,
        marketType: 'swap',
        title: 'title.swapSignals',
      },
    },
    {
      path: '/splashes',
      name: 'signals-splash',
      component: SplashListView,
      meta: {
        layout: DefaultLayout,
        spot: false,
        title: 'title.splashSignals',
      },
    },
    {
      path: '/spot-swap',
      name: 'signals-spot-swap',
      component: SwapListView,
      meta: {
        layout: DefaultLayout,
        marketType: 'spot-swap',
        title: 'title.spotSwapSignals',
      },
    },
    {
      path: '/spot',
      name: 'signals-spot-spot',
      component: SwapListView,
      meta: {
        layout: DefaultLayout,
        marketType: 'spot',
        title: 'title.spotSpotSignals',
      },
    },
    {
      path: '/swap-spot',
      name: 'signals-swap-spot',
      component: SwapListView,
      meta: {
        layout: DefaultLayout,
        marketType: 'swap-spot',
        title: 'title.swapSpotSignals',
      },
    },
    {
      path: '/dex-cex-spot',
      name: 'signals-dex-cex-spot',
      component: DexCexListView,
      meta: {
        layout: DefaultLayout,
        cexSpot: true,
        title: 'title.dexCexSignals',
      },
    },
    {
      path: '/dex-cex-swap',
      name: 'signals-dex-cex-swap',
      component: DexCexListView,
      meta: {
        layout: DefaultLayout,
        cexSpot: false,
        title: 'title.dexCexSignals',
      },
    },
    {
      path: '/dex-dex',
      name: 'signals-dex-dex',
      component: () => import('@/views/signals/DexDexListView.vue'),
      meta: {
        layout: DefaultLayout,
        title: 'title.dexDexSignals',
      },
    },
    {
      path: '/dex-dex-crosschain',
      name: 'signals-dex-dex-crosschain',
      component: () => import('@/views/signals/DexDexCrosschainListView.vue'),
      meta: {
        layout: DefaultLayout,
        title: 'title.dexDexCrosschainSignals',
      },
    },
    {
      path: '/pools/:chain?/:contract?',
      name: 'pools',
      component: PoolsView,
      meta: {
        layout: DefaultLayout,
        title: 'title.pools',
      },
    },
    {
      path: '/funding-signals',
      name: 'signals-funding-rates',
      component: FundingListView,
      meta: {
        layout: DefaultLayout,
        title: 'title.fundingSignals',
      },
    },
    {
      path: '/funding-groups',
      name: 'funding',
      component: FundingGroups,
      meta: {
        layout: DefaultLayout,
        title: 'title.fundingTable',
      },
    },
    {
      path: '/eye/summary/:asset/:chain?/:amount?',
      name: 'eye-dex-asset-common',
      component: EyeCommonView,
      meta: {
        private: true,
        layout: EyeLayout,
        title: 'title.eye',
      },
    },
    {
      path: '/eye/cex-dex/:cex/:asset/:chain',
      name: 'eye-dex-asset-long-legacy',
      redirect(to) {
        return {
          name: 'eye-dex-asset-long',
          params: {
            marketType: 'swap',
            asset: to.params.asset,
            cex: to.params.cex,
            chain: to.params.chain,
          },
        }
      },
    },
    {
      path: '/eye/cex-dex/:marketType/:cex/:asset/:chain/:amount?',
      name: 'eye-dex-asset-long',
      component: EyeDexView,
      meta: {
        private: true,
        long: true,
        layout: EyeLayout,
        title: 'title.eye',
      },
    },
    {
      path: '/eye/:marketType(spot|swap|swap-swap|spot-swap|swap-spot)/:asset/:exBuy/:exSell/:amount?',
      name: 'eye',
      component: EyeCexView,
      meta: {
        private: true,
        layout: EyeLayout,
        title: 'title.eyeSettings',
      },
    },
    {
      path: '/eye/dex',
      name: 'eye-dex-settings',
      component: EyeDexSettingsView,
      meta: {
        layout: DefaultLayout,
        title: 'title.eye',
      },
    },
    {
      path: '/eye',
      name: 'eye-settings',
      component: EyeCexSettingsView,
      meta: {
        layout: DefaultLayout,
        title: 'title.eye',
      },
    },
    {
      name: 'eye-ws-redirect',
      path: '/eye-ws/:marketType/:asset/:exBuy/:exSell/:amount/:expand?',
      redirect: (to) => {
        return {
          name: 'eye',
          params: {
            marketType: to.params.marketType,
            asset: to.params.asset,
            exBuy: to.params.exBuy,
            exSell: to.params.exSell,
            amount: to.params.amount,
          },
        }
      },
    },
    {
      name: 'alerts-swap-redirect',
      path: '/alerts/futures',
      redirect: () => {
        return {
          name: 'signals-swap',
        }
      },
    },
    {
      name: 'alerts-spot-swap-redirect',
      path: '/alerts/spot-futures',
      redirect: () => {
        return {
          name: 'signals-spot-swap',
        }
      },
    },
    {
      name: 'alerts-spot-spot-redirect',
      path: '/alerts/spot-spot',
      redirect: () => {
        return {
          name: 'signals-spot-spot',
        }
      },
    },
    {
      name: 'alerts-swap-spot-redirect',
      path: '/alerts/futures-spot',
      redirect: () => {
        return {
          name: 'signals-swap-spot',
        }
      },
    },
    {
      path: '/eye/:asset',
      name: 'eye-all-asset',
      component: UnderMaintenanceView,
      // component: EyeAllAssetView,
      meta: {
        private: true,
        layout: ErrorLayout,
        title: 'title.eyeAllAsset',
      },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'error',
      component: PageNotFoundView,
      meta: {
        layout: ErrorLayout,
        title: 'title.notFound',
      },
    },
  ],
})

export default router
